import { DataSyncReconnectionConfig } from '../integrations/DataSync/DataSyncReconnectionConfig';
import { DashworksReconnectionConfig } from '../integrations/Dashworks/DashworksReconnectionConfig';
import { getReconnectionConfigByAppId } from '../reconnectionConfigs';
import { OAuthReconnectionConfig } from '../integrations/OAuthIntegrations/OAuthReconnectionConfig';
import { UnifiedAccountIntegrationsReconnectionConfig } from '../integrations/UnifiedAccountIntegrations/UnifiedAccountIntegrationsReconnectionConfig';
export const getReconnectionConfig = ({
  appId,
  isDataSyncApp,
  isDashworksApp,
  isUnifiedAccountSupportedApp,
  hasUrl
}) => {
  const reconnectionConfig = getReconnectionConfigByAppId(appId);
  if (reconnectionConfig) {
    return reconnectionConfig;
  } else if (isUnifiedAccountSupportedApp) {
    return UnifiedAccountIntegrationsReconnectionConfig;
  } else if (isDataSyncApp) {
    return DataSyncReconnectionConfig;
  } else if (isDashworksApp) {
    return DashworksReconnectionConfig;
  } else if (hasUrl) {
    return OAuthReconnectionConfig;
  } else {
    return null;
  }
};